import React from "react";
import Grid from '@mui/material/Grid';
import Slider from "@mui/material/Slider";
import {styled} from '@mui/material/styles';
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import {FormControl, FormHelperText} from "@mui/material";
import FormLabel from "@mui/material/FormLabel/FormLabel";

const iOSBoxShadow =
    '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

const marks = [
    {
        value: 0,
        label: '0 km',
    },
    {
        value: 50,
        label: '50 km',
    },
    {
        value: 100,
        label: '100 km',
    },
    {
        value: 150,
        label: '150 km',
    },
    {
        value: 200,
        label: '200 km',
    },
    {
        value: 250,
        label: '250 km',
    },
];

const IOSSlider = styled(Slider)(({theme}) => ({
    color: theme.palette.mode === 'dark' ? '#3880ff' : '#3880ff',
    height: 2,
    padding: '15px 0',
    '& .MuiSlider-thumb': {
        height: 28,
        width: 28,
        backgroundColor: '#fff',
        boxShadow: iOSBoxShadow,
        '&:focus, &:hover, &.Mui-active': {
            boxShadow:
                '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: iOSBoxShadow,
            },
        },
    },
    '& .MuiSlider-valueLabel': {
        fontSize: 12,
        fontWeight: 'normal',
        top: -6,
        color: theme.palette.text.primary,
        '&:before': {
            display: 'none',
        },
        '& *': {
            background: 'transparent',
            color: '#fff',
        },
    },
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-rail': {
        opacity: 0.5,
        backgroundColor: '#bfbfbf',
    },
    '& .MuiSlider-mark': {
        backgroundColor: '#bfbfbf',
        height: 8,
        width: 1,
        '&.MuiSlider-markActive': {
            opacity: 1,
            backgroundColor: 'currentColor',
        },
    },
}));

export default (data, key) => {
    return (<Grid item md={6} xs={12} key={key}>
        <FormControl error={data.error ? true : false} key={key} component="fieldset" variant="standard">
            <FormLabel component="legend">{data.headerName}{data?.inputProps?.required ? '*' : ''}</FormLabel>
            <IOSSlider
                track={false}
                aria-labelledby="track-false-slider"
                defaultValue={data.defaultValue}
                marks={marks}
                valueLabelDisplay="auto"
                min={0}
                step={5}
                max={250}
                id={`${data.name}-${key}`}
                name={data.name}
                onChange={data.onCallback}
            />
            <Typography gutterBottom>{data.error && (<FormHelperText>{data.error}</FormHelperText>)}</Typography>
        </FormControl>
    </Grid>)
}